import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function initCrosslinksSlider() {
    let perView = 5;

    if (screen.width < 1024) {
        perView = 1;
    }
    if (screen.width >= 1024 && screen.width < 1536) {
        perView = 3;
    }

    // Crosslinks slider based on swiper
    const swiper = new Swiper('.crosslinks-swiper', {
        slidesPerView: perView,
        loop: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slideClass: 'cmeleon-block-content',
    });

    // Align slides centered when number of slides is less than 6 and user is on desktop
    const crosslinkProductsWrapper = document.getElementsByClassName('crosslinks-wrapper')[0];

    if (swiper.slides.length < 6 && screen.width > 1024 && crosslinkProductsWrapper && crosslinkProductsWrapper.getElementsByClassName('crosslinks-products')[0]) {
        crosslinkProductsWrapper.getElementsByClassName('crosslinks-products')[0].classList.add('justify-center');
    }
}
